export default class UrlUtils{
  static normalize (str) {
    // make sure protocol is followed by two slashes
    str = str.replace(/:\//g, '://');

    // remove consecutive slashes
    str = str.replace(/([^:\s])\/+/g, '$1/');

    // remove trailing slash before parameters or hash
    str = str.replace(/\/(\?|&|#[^!])/g, '$1');

    // replace ? in parameters with &
    str = str.replace(/(\?.+)\?/g, '$1&');

    return str;
  }

  static urlJoin() {
    let input = arguments;
    let options = {};

    if (typeof arguments[0] === 'object') {
      // new syntax with array and options
      input = arguments[0];
      options = arguments[1] || {};
    }

    let joined = [].slice.call(input, 0).join('/');
    return this.normalize(joined, options);
  }
}

export function turnIntoRelative(absoluteUrl) {
  const parsedUrl = new URL(absoluteUrl)
  return parsedUrl.pathname + parsedUrl.search
}
